<!-- Kolkata service landing page. Intentionally has no enquiry form: contact is by call / WhatsApp only. -->

<!-- BANNER (only where a suitable existing image is available) -->
<section class="bg-banner pt-0 pb-0 banner-style03" *ngIf="page.banner as b">
    <div class="hero-slider-wrapper">
        <picture>
            <source media="(max-width: 768px)" [srcset]="'/' + b.m" />
            <img [src]="'/' + b.d" class="k-banner-img" [alt]="b.alt" />
        </picture>
    </div>
</section>

<!-- PAGE TITLE -->
<section class="bg-light-red page-title-section k-hero">
    <div class="container">
        <div class="text-center">
            <span class="k-kick">{{ page.tag }} · KOLKATA</span>
            <h1>{{ page.h1 }}</h1>
            <p class="k-sub">{{ page.sub }}</p>
            <div class="k-actions">
                <a routerLink="/bookconsultation" class="btn-style1 text-white small"><span>Book Consultation</span></a>
                <a [href]="whatsapp" class="btn-style1 secondary text-white small" target="_blank"
                    rel="noopener"><span>Chat on WhatsApp</span></a>
            </div>
        </div>
    </div>
</section>

<!-- HIGHLIGHTS -->
<section class="k-section k-light pb-0">
    <div class="container">
        <div class="row g-3 justify-content-center">
            <div class="col-lg-3 col-md-6" *ngFor="let h of highlights">
                <div class="k-highlight">
                    <i class="fas {{ h.icon }}" aria-hidden="true"></i>
                    <span>{{ h.text }}</span>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="k-offer"><b>30% OFF</b>on selected services</div>
            </div>
        </div>
    </div>
</section>

<!-- ABOUT -->
<section class="k-section k-light k-ornate">
    <div class="container k-prose k-panel">
        <h2 class="k-title">{{ page.aboutTitle }}</h2>
        <div class="k-split">
            <figure class="k-figure"><img [src]="'/' + sectionImages.about.src" [alt]="sectionImages.about.alt" width="900" height="600" loading="lazy" decoding="async" /></figure>
            <div class="k-split-text">
                <p *ngFor="let t of page.about">{{ t }}</p>
            </div>
        </div>
    </div>
</section>

<!-- SEO CONTENT -->
<section class="k-section k-ornate">
    <div class="container k-prose k-panel k-panel-cream">
        <h2 class="k-title">{{ page.seoTitle }}</h2>
        <div class="k-split k-split-rev">
            <figure class="k-figure"><img [src]="'/' + sectionImages.section.src" [alt]="sectionImages.section.alt" width="900" height="600" loading="lazy" decoding="async" /></figure>
            <div class="k-split-text">
                <p *ngFor="let t of page.seoParas">{{ t }}</p>
            </div>
        </div>
    </div>
</section>

<!-- TREATMENTS -->
<section class="k-section k-light k-ornate">
    <div class="container">
        <h2 class="k-title">Our Treatments</h2>
        <div class="k-group" *ngFor="let g of groupCards">
            <h3 class="k-group-title">{{ g.title }}</h3>
            <app-kolkata-treatment-carousel [cards]="g.cards"></app-kolkata-treatment-carousel>
        </div>
    </div>
</section>

<!-- WHY CHOOSE -->
<section class="k-section">
    <div class="container k-prose">
        <h2 class="k-title">{{ why.title }}</h2>
        <p *ngFor="let t of why.paras">{{ t }}</p>
    </div>
</section>

<!-- HOW IT WORKS -->
<section class="k-section k-light">
    <div class="container">
        <h2 class="k-title">How It Works</h2>
        <div class="row g-3 justify-content-center">
            <div class="col-lg-3 col-md-6" *ngFor="let s of steps; let i = index">
                <div class="k-step">
                    <span class="k-step-no">{{ i + 1 }}</span>
                    <h3>{{ s.title }}</h3>
                    <p>{{ s.text }}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- FAQ -->
<section class="k-section">
    <div class="container k-faq">
        <h2 class="k-title">Frequently Asked Questions</h2>
        <details *ngFor="let f of page.faqs">
            <summary>{{ f.q }}</summary>
            <p>{{ f.a }}</p>
        </details>
    </div>
</section>
